import React, { useState, useEffect, Children } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./nujobsViewJobsContainer.scss";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import useNuJobsStore from "../../../store/nujobs.store";
import NuJobsViewJobDetails from "../nujobsViewJobDetails";
import { Modal, Button} from "antd";

export default function NuJobsViewJobsContainer({ }) {
    const [isEditMode, setIsEditMode] = useState(false);
    const navigate = useNavigate();
    const { source, jdid } = useParams();   
    const {nujobsApplyNow,ViewedJobs, AppliedJobs,FavJobs,
           skilledBasedJobs,AppliedResponseMetadata,myResumes,profileCompleted,incompleteJDs} = useNuJobDetailsStore();
    const {openJds,setMetaDataViewed} = useNuJobsStore();
    const [jdValues, setJdValues] = useState({});     
    
    function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    } 

    const getJobs = () => {
        switch (source) {
            case "opensearch":
            return openJds;            
            case "search":
            return openJds;
            case "viewed":
            return ViewedJobs;
            case "applied":
            return AppliedJobs;
            case "fav":
            return FavJobs;
            case "skills":
            return skilledBasedJobs;
            case "notification":
            return incompleteJDs;
            default:
            return [];
        }
    };

    const isLoggedin = source == "opensearch"?false:true
    const jobs = getJobs()
    const jd = jobs?.find((j) => j?.QhCompanyJID == jdid);
    const selectedJD = jd;  
    const jdWithLogoIndex = jobs?.findIndex((j) => j?.QhCompanyJID == jdid);
    const getCompanyLogoSrc = (rawLogo) => {
        if (!rawLogo) return null;
        if (rawLogo.startsWith("data:image")) return rawLogo;
        return `data:image/png;base64,${rawLogo}`;
    };
  const companyLogoSrc =
    getCompanyLogoSrc(
      openJds[jdWithLogoIndex]?.companylogo ||
        openJds[jdWithLogoIndex]?.CompanyLogo ||
        openJds[jdWithLogoIndex]?.JDClient?.CompanyLogo,
    ) || null;

  const isApplied = ()=>{
        const appIdx = AppliedResponseMetadata?.findIndex((j) => j?.qhcompanyjid == jd?.QhCompanyJID );
        if(AppliedResponseMetadata?.[appIdx]?.isApplied=== true){
           return "Applied"
        }else{
           return "Not Applied"
        }
        return "Not Applied"
    }
    const appliedOn = jd?.nujobsinfo?.appliedon
    const initJDParams = () =>{
        var jdValuesTmp
        if (source !== undefined) {
            jdValuesTmp = {
                job_category: selectedJD?.JDDetails.JobCategory,
                title: selectedJD?.JDDetails.Title,
                client_job_type: selectedJD?.JDClient.ClientJobType,
                job_type: selectedJD?.JDDetails.JobType,
                job_time: selectedJD?.JDDetails.JobTime,
                designation: selectedJD?.JDDetails.Designation,
                roles_and_responsibility: selectedJD?.JDRequired.RoleDetails,
                roletype: selectedJD?.JDRequired.RoleType,
                role: selectedJD?.JDRequired.Role,
                skills: selectedJD?.JDRequired.Skills,
                keywords: selectedJD?.JDRequired.Keywords,
                education: selectedJD?.JDRequired.Education,
                min_ctc: selectedJD?.JDProject.MinCtc,
                max_ctc: selectedJD?.JDProject.MaxCtc,
                postingdate: selectedJD?.JDOther.PostingDate,
                work_location: selectedJD?.JDRequired.WorkLocation?.join(", "),
                work_mode: selectedJD?.JDRequired.WorkMode,
                diversity_only: selectedJD?.JDRequired.Diversity,
                freshers_only: selectedJD?.JDRequired.Fresher,
                interns_only: selectedJD?.JDRequired.Intern,                                                                          
                notice_period: selectedJD?.JDRequired.NoticePeriod,
                min_exp: selectedJD?.JDRequired.MinExperience,
                max_exp: selectedJD?.JDRequired.MaxExperience,
                updatedon: formatUnixDate(selectedJD?.timestamp),
                postedby: selectedJD?.CompanyName,             
            };
            setJdValues(jdValuesTmp);
        }
    }
    //selected jd from table
    useEffect(() => {       
        initJDParams(); 
        if(source !== "opensearch"){
            setMetaDataViewed(jdWithLogoIndex)
        }  
    }, []);

    const encodeJson = () =>{
        let encodedJsonValues ={};
       
        //now override keyword and location
        encodedJsonValues.qhoid= jd?.QhOID;
        encodedJsonValues.qhcompanyjid=jd?.QhCompanyJID;
        encodedJsonValues.companyname=selectedJD.companyname;                           
        return encodedJsonValues
    }

    const handleApplyNow = () =>{
            navigate("/nujobshome/nujobssearch")
    }
    const applyNowCallBackLoggedIn = async (encodedJsonCB) => {
        if(myResumes?.filter((item) => item.resumestatus != "NO_RES")?.length > 0 && profileCompleted > 0){
            try {
                var encodedJsonValues = encodedJsonCB()
                await nujobsApplyNow(0, encodedJsonValues,handleApplyNow);                
            } catch (err) {
            alert("Application failed. Please try again.");
            return err;
            }
        }else{
            // Trigger the Modal only if NOT logged in
            Modal.confirm({
                title: "Missing Resume/ Incomplete Profile",
                content:
                "Resume is not uploaded or Profile is not complete.",
                okText: "Sign In",
                cancelButtonProps: { style: { display: "none" } },
                centered: true,
                closable: true,
                maskClosable: true,
                onCancel: () => {
                console.log("Modal closed or cancelled");
                },        
                footer: (
                <div
                    style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    paddingBottom: "10px",
                    marginTop: "20px",
                    }}
                >
                    <Button
                    style={{
                        fontFamily: 'Segoe UI',               
                        color: "#7c8cce",
                        padding: "0 30px",
                        borderRadius: "8px",
                        border: "10px",
                        border: "1px solid #96a5e2",
                        fontSize: "12px",
                        fontWeight: 600,
                        cursor: "pointer",
                        transition: "0.2s ease",
                        backgroundColor:"#fff"
                    }}
                    onClick={() => {
                        Modal.destroyAll(); // Close the modal manually
                        navigate("/nujobshome/nujobssearch")
                    }}
                    >
                    OK
                    </Button>
                </div>
                ),
            });            
        }

    };
    
    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }
 


    return (        
	    <NuJobsViewJobDetails
	      jobId={jd?.QhCompanyJID}
	      jdValues={jdValues}
	      encodeJsonCB={encodeJson}
	      isApplied={isApplied}
	      appliedOn={appliedOn}
	      companyLogo={companyLogoSrc}
          isLoggedin= {isLoggedin}
          applyNowCallBackLoggedIn ={applyNowCallBackLoggedIn}
	    />
    );
}
